import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import React from "react";

import { language } from "../../../../language";
import { getUnitPropertie } from "../../../smart/camunda/forms/functions";

export default class Minute {
  static DisplayTab(props) {
    const { onChange, state, onCheckChange, onPropertieChange } = props;

    const readOnly = getUnitPropertie(state, "readOnly");
    const label = getUnitPropertie(state, "label") || "";

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onChange(event)}
            name="id"
            variant="outlined"
            id="id"
            label="Id"
            value={state.id || ""}
            fullWidth
            helperText={language.toolTipId}
          />
        </Grid>

        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="label"
            variant="outlined"
            id="label"
            label={language.propertieLabel}
            value={label || ""}
            fullWidth
            helperText={language.toolTipLabel}
          />
        </Grid>

        <Grid item size={12}>
          <TextField
            onChange={(event) => onChange(event)}
            name="description"
            variant="outlined"
            id="descricao"
            label={language.propertieDescription}
            value={state.description || ""}
            fullWidth
            helperText={language.toolTipDescription}
          />
        </Grid>

        <Grid item size={12}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  name="readOnly"
                  onChange={(event) => onCheckChange(event)}
                  value={readOnly}
                  checked={readOnly || false}
                />
              }
              label={language.propertieReadonly}
            />
          </FormGroup>
        </Grid>
      </Grid>
    );
  }

  static ValidationTab(props) {
    const {
      onPropertieChange,
      state,
      documentTemplates,
      docTypes,
      handlePropertieChangeDocumentType,
    } = props;

    const documentType = getUnitPropertie(state, "documentType");
    const template = getUnitPropertie(state, "template");

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            select
            name="documentType"
            onChange={handlePropertieChangeDocumentType}
            value={documentType}
            label={language.documentType}
            variant="outlined"
            renderValue={(selected) => (selected ? selected.name : "")}
            fullWidth
          >
            {docTypes &&
              docTypes?.content?.map((doc) => {
                return (
                  <MenuItem key={doc.id} value={doc}>
                    {doc.name}
                  </MenuItem>
                );
              })}
          </TextField>
        </Grid>

        <Grid item size={12}>
          <TextField
            select
            name="template"
            onChange={onPropertieChange}
            value={template}
            label={language.template}
            variant="outlined"
            renderValue={(selected) => (selected ? selected.name : "")}
            fullWidth
          >
            {documentTemplates &&
              documentTemplates?.content?.map((temp) => {
                return (
                  <MenuItem key={temp.id} value={temp}>
                    {temp.name}
                  </MenuItem>
                );
              })}
          </TextField>
        </Grid>
      </Grid>
    );
  }

  static StylesTab(props) {
    const { onPropertieChange, state, classes } = props;

    const height = getUnitPropertie(state, "height");

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            onChange={(event) => {
              const value = event.target.value;
              value && (event.target.value = value <= 0 ? 0 : value);
              onPropertieChange(event);
            }}
            name="height"
            variant="outlined"
            label={language.height}
            type="number"
            value={height || ""}
            fullWidth
            helperText={language.toolTipHeight}
          />
        </Grid>
      </Grid>
    );
  }
}
